import { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import GamesPage from "./pages/GamesPage";
import ColorClashPage from "./pages/ColorClashPage";
import WealthEmpirePage from "./pages/WealthEmpirePage";
import PrivacyPage from "./pages/PrivacyPage";
import "./styles/global.css";

export default function App() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const scrollToFeatures = () => {
    if (location.pathname === "/") {
      setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  return (
    <>
      <Navbar scrolled={scrolled} navigate={navigate} scrollToFeatures={scrollToFeatures} />

      <Routes>
        <Route path="/" element={<HomePage navigate={navigate} />} />
        <Route path="/games" element={<GamesPage navigate={navigate} />} />
        <Route path="/games/color-clash" element={<ColorClashPage navigate={navigate} />} />
        <Route path="/games/wealth-empire" element={<WealthEmpirePage navigate={navigate} />} />
        <Route path="/privacy" element={<PrivacyPage navigate={navigate} />} />
      </Routes>

      <footer style={{
        background: "#07070F",
        borderTop: "1px solid rgba(255,255,255,0.06)",
        padding: "40px 5%",
        textAlign: "center"
      }}>
        <div style={{
          fontFamily: "'Fredoka One', cursive", fontSize: 26,
          background: "linear-gradient(90deg, #A855F7, #6C3CE1, #3EAEFF)",
          WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          marginBottom: 6
        }}>NovuliGames</div>
        <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 13, marginBottom: 20 }}>
          Crafting fun, one game at a time 🎮
        </div>

        {/* Game quick links */}
        <div style={{ display: "flex", justifyContent: "center", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
          {[
            { label: "🎨 Color Clash", path: "/games/color-clash", color: "#FF4757" },
            { label: "💰 Wealth Empire", path: "/games/wealth-empire", color: "#FFD700" },
          ].map(({ label, path, color }) => (
            <span
              key={path}
              onClick={() => navigate(path)}
              style={{
                fontSize: 12, cursor: "pointer", fontWeight: 700,
                padding: "4px 14px", borderRadius: 20,
                background: `${color}18`, border: `1px solid ${color}33`,
                color, transition: "opacity 0.2s",
              }}
              onMouseEnter={e => e.currentTarget.style.opacity = "0.7"}
              onMouseLeave={e => e.currentTarget.style.opacity = "1"}
            >{label}</span>
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: 28, marginBottom: 24, flexWrap: "wrap" }}>
          <span className="nav-link" style={{ fontSize: 13 }} onClick={() => navigate("/")}>Home</span>
          <span className="nav-link" style={{ fontSize: 13 }} onClick={() => navigate("/games")}>Games</span>
          <span className="nav-link" style={{ fontSize: 13 }} onClick={scrollToFeatures}>Features</span>
          <span className="nav-link" style={{ fontSize: 13 }} onClick={() => navigate("/privacy")}>Privacy Policy</span>
        </div>
        <div style={{ color: "rgba(255,255,255,0.25)", fontSize: 12 }}>© 2026 NovuliGames. All rights reserved.</div>
      </footer>
    </>
  );
}